import { MARKET } from '../../shared/market.generated';
import type { MarketSnapshot } from '../../shared/types';
import { BRAND } from '../brand';
import { explorerAddress } from '../data/tx';
import { shortAddr, timeAgo } from '../lib/format';
import { linkTo } from '../router';

export function Footer({ market }: { market: MarketSnapshot | undefined }) {
  return (
    <footer className="footer">
      <nav className="footer__links" aria-label="Footer">
        <a {...linkTo('/status')}>System status</a>
        <a href={BRAND.faucetUrl} target="_blank" rel="noopener noreferrer">Official testnet faucet</a>
        <a href={MARKET.explorer} target="_blank" rel="noopener noreferrer">Block explorer</a>
        <a href={explorerAddress(MARKET.pool)} target="_blank" rel="noopener noreferrer">Pool <span className="mono">{shortAddr(MARKET.pool)}</span></a>
      </nav>
      <p>Experimental testnet deployment for evaluation only. Not an offer of financial services. Not affiliated with, or endorsed by, Aave or Robinhood. Built on {BRAND.upstream}.</p>
      {market && <p>Market data: {market.origin === 'edge' ? 'edge snapshot' : 'read directly from the chain'}, updated {timeAgo(Math.floor(market.fetchedAt / 1000))}.</p>}
    </footer>
  );
}
